var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "#3D93DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.745 4.293c.202 0 .397.015.586.044.192.026.384.062.576.107l-.141.982a3.082 3.082 0 00-.972-.161c-.25 0-.477.037-.679.112a1.299 1.299 0 00-.508.342c-.14.15-.247.343-.322.58-.055.185-.089.397-.101.636h1.742v.669H7.178v.64h1.748v.668H7.18c.006.284.042.53.109.737.078.228.187.416.327.562.14.143.308.249.503.317.199.069.418.103.66.103.175 0 .346-.013.512-.04.166-.025.324-.064.474-.116l.141.976a5.443 5.443 0 01-.59.108c-.206.026-.414.039-.626.039-.4 0-.768-.059-1.103-.176a2.405 2.405 0 01-.864-.523 2.422 2.422 0 01-.572-.869 3.31 3.31 0 01-.196-1.118h-.849v-.669h.845v-.64h-.845v-.668h.853a3.34 3.34 0 01.192-1.02c.137-.359.33-.658.577-.9.25-.24.545-.42.883-.541.342-.12.72-.181 1.133-.181z",
    fill: "#000"
  })));
}
SvgPokerGameTypeEur.displayName = 'PokerGameTypeEur';
export default SvgPokerGameTypeEur;